import { Currency } from '~/features/dashboard/store/models';

export const fakeDeal = {
    balanceCurrency: Currency.USD,
    terms: {},
    description: '',
    notes: [],
    keyDates: [],
    paymentDates: [],
    advancesDates: [],
    royaltyRates: [],
    royaltyStatement: {
        royaltyCollection: '',
        paidTo: '',
        logIn: '',
        password: '',
    },
    recoupableItems: [],
    deliveredProductTypes: ['album', 'singles', 'artwork', 'videos'],
};
